import { render, staticRenderFns } from "./AdminHome.vue?vue&type=template&id=1988d25c&scoped=true"
import script from "./AdminHome.vue?vue&type=script&lang=js"
export * from "./AdminHome.vue?vue&type=script&lang=js"
import style0 from "./AdminHome.vue?vue&type=style&index=0&id=1988d25c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1988d25c",
  null
  
)

export default component.exports